<template>
  <div class="w-full flex flex-col lg:flex-row">
    <AppNavbar class="hidden lg:block" />
    <AppNavbarFooter class="block lg:hidden" />
    <router-view></router-view>
  </div>
</template>

<script>
import AppNavbar from "./AppNavbar.vue";
import AppNavbarFooter from "./AppNavbarFooter.vue";
export default {
  components: {
    AppNavbar,
    AppNavbarFooter
  },
  async created() {
    // console.log(this.$store.hasModule("globalApp"));
    // if (!this.$store.hasModule("globalApp"))
    //   await this.$store.registerModule("globalApp", moduleApp);
    // console.log(this.$store.hasModule("globalApp"));
  },

  mounted() {},
  methods: {
    hasSlot(name = "default") {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    }
  },
  computed: {}
};
</script>
